import { items } from "@wix/data";



export class VolumeDiscountRepository {

  constructor(args) {
    this._collectionId = `${args.namespace}/VolumeDiscounts`;
  }

  async create(volumeDiscount) {
    return items.insert(this._collectionId, volumeDiscount);

  }

  
  async update(volumeDiscount) {
    return items.update(this._collectionId, volumeDiscount);
  }


  async getAll() {
    return items.query(this._collectionId).find();
  }


  async getFirstById(id) {
    return (
      (await items.query(this._collectionId).eq("_id", id).find()).items[0] ??
      null
    );
  }


  async getFirstByTitle(title) {
    return (
      (await items.query(this._collectionId).eq("title", title).find())
        .items[0] ?? null
    );
  }


  async getFirstByProductId(id) {
    return (
      (
        await items
          .query(this._collectionId)
          .hasSome("productIds", id)
          .descending("createdAt")
          .find()
      ).items[0] ?? null
    );
  }


  async getFirstByApplyTo(applyTo) {
    return (
      (
        await items
          .query(this._collectionId)
          .hasSome("applyTo", applyTo)
          .descending("createdAt")
          .find()
      ).items[0] ?? null
    );
  }


  async delete(id) {
    return items.remove(this._collectionId, id);
  }


  getDummyData() {
    return {
      _id: "b2aa9b56-ca46-4b57-4f5b-f0a752b88610",
      title: "Volume Discount example",
      discountRuleName: "Summer Sale",
      isEnabled: true,
      applyTo: "ALL_PRODUCTS",
      offers: [
        {
          title: "Offer #1",
          discountRuleId: "discountRuleId",
          quantityFrom: 2,
          quantityTo: null,
          amountType: "PERCENTAGE",
          amount: 10,
          image: {
            base64: "null",
            cornerRadius: 8,
            size: 80,
          }
        },
      ],
      startTimestamp: new Date().toISOString(),
      endTimestamp: null,
      productIds: ["b2aa9b56-ca46-4b57-4f5b-f0a752b88610"],
      block: {
        title: "Save & Smile:)",
        addToCartText: "Add to cart",
        offerSummaryTitle:
          "Buy {{OFFER_QUANTITY}} and save {{OFFER_TOTAL_PRICE_DISCOUNT_DIFFERENCE}}",
        offerSummaryTitleStandard: "Standard Price",
        layout: "vertical",
      },
      style: {
        blockTitle: {
          text: {
            color: {
              hex: "#000000",
              alpha: 1,
            },
            size: 14,
            weight: "normal",
            style: "normal",
            isGradient: false,
          },
          border: {
            color: {
              hex: "#000000",
              alpha: 1,
            },
            isGradient: false,
          },
        },
        offer: {
          default: {
            padding: 12,
            background: {
              color: {
                hex: "#ffffff",
                alpha: 1,
              },
              isGradient: false,
            },
            border: {
              radius: 0,
              color: {
                hex: "#cfcfcf",
                alpha: 1,
              },
              isGradient: false,
            },
          },
          active: {
            background: {
              color: {
                hex: "#cfcfcf",
                alpha: 1,
              },
              isGradient: false,
            },
            border: {
              color: {
                hex: "#000000",
                alpha: 1,
              },
              isGradient: false,
            },
          },
        },
        title: {
          default: {
            text: {
              color: {
                hex: "#000000",
                alpha: 1,
              },
              size: 14,
              weight: "normal",
              style: "normal",
            },
          },
          active: {
            text: {
              color: {
                hex: "#222222",
                alpha: 1,
              },
            },
          },
        },
        subtitle: {
          default: {
            text: {
              color: {
                hex: "#000000",
                alpha: 1,
              },
              size: 14,
              weight: "normal",
              style: "normal",
            },
          },
          active: {
            text: {
              color: {
                hex: "#222222",
                alpha: 1,
              },
            },
          },
        },
        price: {
          default: {
            text: {
              color: {
                hex: "#000000",
                alpha: 1,
              },
              size: 14,
              weight: "normal",
              style: "normal",
            },
          },
          active: {
            text: {
              color: {
                hex: "#222222",
                alpha: 1,
              },
            },
          },
        },
        discountPrice: {
          default: {
            text: {
              color: {
                hex: "#000000",
                alpha: 1,
              },
              size: 14,
              weight: "normal",
              style: "normal",
            },
          },
          active: {
            text: {
              color: {
                hex: "#222222",
                alpha: 1,
              },
            },
          },
        },
        addToCartButton: {
          default: {
            background: {
              color: {
                hex: "#222222",
                alpha: 1,
              },
              isGradient: false,
            },
            border: {
              radius: 0,
            },
            text: {
              size: 14,
              weight: "normal",
              style: "normal",
              color: {
                hex: "#ffffff",
                alpha: 1,
              },
            },
          },
          active: {
            background: {
              color: {
                hex: "#16FF7A",
                alpha: 1,
              },
              isGradient: false,
            },
            text: {
              size: 14,
              weight: "normal",
              style: "normal",
              color: {
                hex: "#ffffff",
                alpha: 1,
              },
            },
          },
        },
      },
      settings: {
        allowMultipleVariationSelection: true,
      },
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
  }
}
